<template>
  <a-card>
    <a-row :gutter="12" style="margin-bottom:1rem" >
      <a-col :md="8" :xl="10" :lg="3" v-if="cityNum.length>0">
        <a-alert message="已开启省份：" type="success" :description="provinceNum.toString()"/>
      </a-col>
    </a-row>
    <a-row :gutter="12" style="margin-bottom:1rem">
      <a-col :md="8" :xl="10" :lg="3" v-if="cityNum.length>0">
        <a-alert type="info" message="已开启城市：" :description="cityNum.toString()" />
      </a-col>
    </a-row>
    <a-row :gutter="12" style="margin-bottom:1rem">
      <a-col :md="8" :xl="10" :lg="3" >
        <a-alert message="请保证抢单区域的每一个区或县的价格不为零，否则你无法开启该区域抢单" banner />
      </a-col>
    </a-row>
    <a-row :gutter="1" style="margin-bottom:1rem">
      <a-col :md="6" :sm="24">
        <a-form :form="from" layout="inline">
          <a-form-item label="省份选择：">
            <a-select v-model="province" style="width: 8rem" @change="handleProvinceChange" allowClear>
              <a-select-option v-for="province in provinceData" :key="province.provinceCode" >
                {{ province.provinceName }}
              </a-select-option>
            </a-select>
          </a-form-item>
        </a-form>
      </a-col>
      <a-col :md="6" :sm="24">
        <a-form :form="from" layout="inline">
          <a-form-item label="城市名称：">
            <a-select v-model="city" style="width: 8rem" @change="handleCityChange">
              <a-select-option v-for="city in cityData" :key="city.cityCode">
                {{ city.cityName }}
              </a-select-option>
            </a-select>
          </a-form-item>
        </a-form>
      </a-col>
      <a-col :span="4" v-if="isShowOpen&&city">
        <a-form :form="from" layout="inline">
          <a-form-item label="是否启动：">
            <a-switch checked-children="开" un-checked-children="关" @change="onChange" v-model="isOpen" />
          </a-form-item>
        </a-form>
      </a-col>
    </a-row>
    <a-table
      bordered
      v-if="city"
      :columns="columns"
      :data-source="data"
      :pagination="false"
      size="middle">
      <template v-for="col in ['areaAmount']" :slot="col" slot-scope="text, record, index" >
        <div :key="col">
          <a-input-number
            :value="text"
            v-if="record.editable"
            size="small"
            :min="0"
            @change="
              e => handleChange(e, record.areaCode, col)"
          />
          <template v-else>
            {{ text }}
          </template>
          </a-input-number></div>
      </template>
      <template slot="operation" slot-scope="text, record, index">
        <div >
          <span v-if="record.editable">
            <a @click="() => save(record.areaCode)" >保存</a>
          </span>
          <span v-else>
            <a :disabled="editingKey !== ''" @click="() => edit(record.areaCode,index)">编辑</a>
          </span>
        </div>
      </template>
    </a-table>
  </a-card>
</template>
<script>
import { getselectAllProvince, getselectCityName } from '@/api/enterprise/enterprise'
import { getGrabAreaList, getProvinceByStartOrNot, getCityByStartOrNot, updateAreaPrice, updateAreaFlag } from '@/api/basicdatas/GrabArea'

const columns = [
  {
    title: '区县名称',
    key: 'areaName',
    dataIndex: 'areaName',
    align: 'center',
    width: '10rem'
  },
  {
    title: '区域价格',
    dataIndex: 'areaAmount',
    key: 'areaAmount',
    scopedSlots: { customRender: 'areaAmount' },
    align: 'center',
    width: '10rem'
  },
  {
    title: '操作',
    dataIndex: 'operation',
    key: 'operation',
    scopedSlots: { customRender: 'operation' },
    align: 'center',
    width: '10rem'
  }
]
export default {
  name: 'GrabArea',
  components: {

  },
  data () {
    return {
      form: this.$form.createForm(this, { name: 'form' }),
      provinceData: [], // 省份数据
      cityData: [], // 城市数据
      province: '', // 下拉选择的省份
      city: '', // 下拉选择的城市
      isOpen: false, // 是否开启
      data: [], // 区域表格数据
      columns, // 表头以及表格定义
      editingKey: '', // 点击编辑，其他编辑禁用
      cityCode: '', // 选择城市的Code
      provinceCode: '', // 选择省份Code
      provinceNum: [], // 已开启省份的名单
      cityNum: [], // 已开启城市的名单
      cacheData: [],
      areaAmount: '', // 价格
      isShowOpen: false // 是否展示“是否开启开关”
    }
  },
  filters: {},
  created () {
  },
  mounted () {
    this.getselectAllProvince()
    this.getProvinceByStartOrNot()
    this.getCityByStartOrNot()
  },
  methods: {
    // 获取省份
    async getselectAllProvince () {
      try {
        const res = await getselectAllProvince()
        this.provinceData = res.rows
      } catch (err) {
        console.log(err)
      }
    },
    // 获取城市
    async getselectCityName (provinceCode) {
      try {
        this.provinceCode = provinceCode
        const res = await getselectCityName({
          provinceCode: provinceCode
        })
        this.cityData = res.rows
      } catch (err) {
        console.log(err)
      }
    },
    // 获取已开启试点省份
    async getProvinceByStartOrNot () {
      try {
        const res = await getProvinceByStartOrNot({
          startOrNot: 1
        })
        const num = res.rows
        this.provinceNum = num.map(item => item.provinceName)
      } catch (err) {
        console.log(err)
      }
    },
    // 获取已开启试点城市
    async getCityByStartOrNot () {
      try {
        const res = await getCityByStartOrNot({
          startOrNot: 1
        })
        const num = res.rows
        this.cityNum = num.map(item => item.cityName)
      } catch (err) {
        console.log(err)
      }
    },
    // 获取城市的抢单价格列表
    async getGrabAreaList () {
      try {
        const res = await getGrabAreaList({
          provinceCode: this.provinceCode,
          cityCode: this.cityCode
        })

        this.getselectCityName(this.provinceCode)// 修改是否开启后需要重新获取城市
        if (res.data == null) {
          this.data = []
        } else {
          this.data = res.data
        }
        this.editingKey = ''
        this.cacheData = this.data.map(item => ({ ...item }))
        this.data.forEach(item => {
          if (item.areaAmount == 0) {
            this.isShowOpen = false
          } else {
            this.isShowOpen = true
          }
        })
      } catch (err) {
        console.log(err)
      }
    },
    // 修改价格
    async updateAreaPrice (areaCode) {
      try {
        const res = await updateAreaPrice({
          areaAmount: this.areaAmount,
          startOrNot: this.isOpen ? 1 : 0,
          cityCode: this.cityCode,
          areaCode: areaCode
        })
        this.getGrabAreaList()
      } catch (err) {
        console.log(err)
      }
    },
    // 选择省份，并且获取城市
    handleProvinceChange (provinceCode) {
      this.provinceCode = provinceCode
      this.city = ''
      this.isOpen = false
      this.getselectCityName(this.provinceCode)
    },
    // 选择城市
    handleCityChange (e) {
      this.cityCode = e
      this.cityData.forEach(item => {
        if (item.cityCode == e) {
          if (item.startOrNot == 0) {
            this.isOpen = false
          } else {
            this.isOpen = true
          }
        }
      })
      this.getGrabAreaList()
    },
    // 是否开启抢单
    onChange (e) {
      this.isOpen = e
      this.updateAreaFlag(e)
      this.getGrabAreaList()
    },
    // 点击编辑，修改输入框的值
    handleChange (value, key, column) {
      this.areaAmount = value
      const newData = [...this.data]
      const target = newData.filter(item => key === item.areaCode)[0]
      if (target) {
        target[column] = value
        this.data = newData
      }
    },
    // 编辑
    edit (key, index) {
      this.areaAmount = this.data[index].areaAmount
      const newData = [...this.data]
      const target = newData.filter(item => key === item.areaCode)[0]
      this.editingKey = key
      if (target) {
        target.editable = true
        this.data = newData
      }
    },
    // 保存
    save (key) {
      const newData = [...this.data]
      const newCacheData = [...this.cacheData]
      const target = newData.filter(item => key === item.areaCode)[0]
      const targetCache = newCacheData.filter(item => key === item.areaCode)[0]
      if (target && targetCache) {
        delete target.editable
        this.data = newData
        Object.assign(targetCache, target)
        this.cacheData = newCacheData
      }
      this.updateAreaPrice(key)
      this.editingKey = ''
      // this.cancel()
    },
    // 调用是否开启抢单的接口
    async updateAreaFlag (e) {
      try {
        const res = await updateAreaFlag({
          provinceCode: this.provinceCode,
          cityCode: this.cityCode,
          startOrNot: e ? 1 : 0
        })
        this.getProvinceByStartOrNot()
        this.getCityByStartOrNot()
        this.getGrabAreaList(e)
      } catch (err) {
        console.log(err)
      }
    }
  }
}
</script>

<style scoped>

</style>
